import { type BaseButtonProps } from './types';
import styles from './button.module.scss';
import { CustomWhiteIconLoading } from '../icons';

const Button = ({
  className = '',
  fit = false,
  variant = 'default',
  size = 'md',
  status = 'default',
  loading = false,
  loadingIcon,
  children,
  ...props
}: BaseButtonProps) => {
  return (
    <button
      className={`${styles.button} ${className}`}
      data-status={status}
      data-size={size}
      data-variant={variant}
      data-fit={fit}
      data-loading={loading}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && (loadingIcon || <CustomWhiteIconLoading className={styles.loadingIcon} data-loading="true" />)}
      <div className={styles.buttonContent}>{children}</div>
    </button>
  );
};

export { Button };
